(function(root){
 const UPGRADE='14-karat gold charm upgrade';
 const STANDARD='Leather cover';
 const isUpgrade=value=>value===UPGRADE;
 const resolve=(variants,selected)=>variants.find(v=>v.options.length===selected.length&&v.options.every((value,i)=>value===selected[i]));
 function sibling(variants,names,interior,finish){
  const interiorIndex=names.indexOf('Interior'), finishIndex=names.indexOf('Finish');
  const matching=variants.filter(v=>finishIndex<0||v.options[finishIndex]===finish);
  return matching.find(v=>interiorIndex<0||v.options[interiorIndex]===interior)||matching.find(v=>v.available)||matching[0];
 }
 function finishVariant(variants,names,selected,finish){const options=selected.slice();const i=names.indexOf('Finish');if(i<0)return undefined;options[i]=finish;return resolve(variants,options);}
 const api={UPGRADE,STANDARD,isUpgrade,resolve,sibling,finishVariant};
 if(typeof module!=='undefined'&&module.exports)module.exports=api;else root.ArrondiVariants=api;
})(typeof globalThis!=='undefined'?globalThis:this);
